<template>
    <div class="text-left">
        <EmbeddedQuiz v-if="showQuiz && topic_completed !== 'true'" :questionObj="quiz_questions" @completed="setCompleted"></EmbeddedQuiz>
        <PurpleButton v-if="!showQuiz && topic_completed === 'false'" buttonText="Test your knowledge" @pressed="showQuestions" class="test-knowledge"></PurpleButton>
        <br><br>
        <div class="text-left">
            <div class="message" v-if="topic_completed !== 'true' && topic_completed !== 'false' && !showQuiz">
                You scored <b>{{topic_completed}}%</b> <br>
                Ah, you need more practice. Retake quiz?
            </div>
            <div class="message" v-if="topic_completed === 'true'">
                <lottie class="lottie-anim" :options="defaultOptions" :height="60" :width="60" v-on:animCreated="handleAnimation"/><br>
                <span class="text-center">
                    Awesome, you've completed this topic with a score of <b>100%</b>
                </span>
            </div>
            
            <PurpleButton v-if="topic_completed !== 'true' && topic_completed !== 'false' && !showQuiz" buttonText="Retake Quiz" @pressed="retakeQuiz" class="test-knowledge"></PurpleButton>
            <PurpleButton v-if="topic_completed === 'true'" buttonText="Next Topic" @pressed="goToNextTopic" class="test-knowledge"></PurpleButton>
        </div>
    </div>


</template>


<script>
import {codemirror} from 'vue-codemirror'
import PurpleButton from '../components/PurpleButton.vue'
import EmbeddedQuiz from '../components/EmbeddedQuiz.vue'
import lottie from 'vue-lottie'
import * as animationData from '../assets/animations/1127-success.json'

export default {
    name: 'QuizComponent',
    components: {
        lottie,
        PurpleButton,
        codemirror,
        EmbeddedQuiz
    },
    props: {
        quiz_questions: Array,
        slug_topic: String
    },
    data: function() {
        return {
            defaultOptions: {
                animationData: animationData.default,
                loop: false,
                autoplay: true
            },
            animationSpeed: 1,
            showQuiz: false,
            topicQuizScore: 0,
            nextTopicTable: {},
            topic_completed: 'false'
        }
    }, 
    created() {
        this.showQuiz = false;
        this.topic_completed = localStorage.getItem(this.slug_topic);
    },
    methods: {
        showQuestions() {
            this.showQuiz = true;
        },
        //only have setCompleted here, not setAttempted. setCompleted does the work of setAttempted also, todo
        setCompleted(score) {
            this.topicQuizScore = score;
            this.showQuiz = false;
            if (score === 100) {
                this.topic_completed = 'true';
                this.$emit('completed', this.slug_topic);
            }
            
            else {
                this.topic_completed = score;
                this.$emit('attempted', this.slug_topic, score);
            }
        },  
        goToNextTopic() {
            this.$emit('next');
        },
        retakeQuiz() {
            this.showQuiz = true;
        },
        handleAnimation: function(anim) {
            this.anim = anim;
        }
    }
}
</script>


<style scoped>
    .lottie-anim {
        margin: 0px !important;
    }

</style>

